// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"_2ohhniZQlDkEtARNAXT9Z8"};